import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", (e) => this.validate(e))
  }

  validate(event) {
    const requiredFields = this.element.querySelectorAll("[required]")
    let valid = true

    requiredFields.forEach((field) => {
      const isEmpty = !field.value?.trim()
      if (isEmpty) {
        field.style.borderColor = "red"
        valid = false
      } else {
        field.style.borderColor = ""
      }
    })

    if (!valid) {
      event.preventDefault()
    }
  }
}
